var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"modal"}}),_c(_setup.ModalHost)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }